import { render, staticRenderFns, recyclableRender, components } from "./personal-data.vue?vue&type=template&id=28785dd8&scoped=true&"
var renderjs
import script from "./personal-data.vue?vue&type=script&lang=js&"
export * from "./personal-data.vue?vue&type=script&lang=js&"
import style0 from "./personal-data.vue?vue&type=style&index=0&id=28785dd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28785dd8",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/mine/personal-data.vue"
export default component.exports